import AnimatedCircles from "../components/Animation";
import { useEffect, useState } from "react";
import Test from "../components/Welc";
import Test2 from "../components/animPage";

const Home = () => {
  const [showTest, setShowTest] = useState(true);
  const [showTest2, setShowTest2] = useState(false);

  useEffect(() => {
    const test2Timeout = setTimeout(() => {
      setShowTest2(true);
      setShowTest(false);
    }, 2500);

    return () => clearTimeout(test2Timeout);
  }, []);

  return (
    <section>
      <div className="cont">
        <AnimatedCircles />
        {showTest && <Test />}
        {showTest2 && <Test2 />}
      </div>
    </section>
  );
};

export default Home;
